<template>
	<view class="container myuser-page">
		<view class="user">
			<image class="user-photo" :src="userInfo.u_id? userInfo.u_logo: '/static/userlogo.jpg'"></image>
			<text class="user-nick">{{userInfo.u_id? userInfo.u_nickname : '游客'}}</text>
		</view>
		<button class="mar10" v-if="userInfo.u_id" type="default" @tap="logout">退出登录</button>
	</view>
</template>

<script>
	const app = getApp();
	export default {
		data() {
			return {
				userInfo: {}
			}
		},
		onShow: function (option) {
			var that = this;
			app.mustLogin(function(data){
				that.userInfo = app.globalData.userInfo;
			});
		},
		methods: {
			logout: function(){
				var that = this;
				that.userInfo = {};
				app.globalData.userInfo = null;
				uni.removeStorageSync('unitag');
				uni.navigateTo({ url: '/pages/user/login'});
			}
		}
	}
</script>

<style>
.user{
	height: 80px;
	background: #df0707;
	color: #FFFFFF;
}
.user .user-photo {width: 50px; height: 50px; border-radius: 50%;margin: 15px 15px;}
.user .user-nick {position: absolute;line-height: 80px;font-weight: 500;padding-right: 10px;font-size: 15px;}
</style>